import React, { useState, type ForwardedRef } from 'react';
import SvgIcon from 'components/Globals/Base/SvgIcon';
import useBreakpoint from 'hooks/useBreakpoint';
import Link from 'components/Globals/Base/Link';
import * as S from './CompanyCard.styles';

export interface CompanyCardProps {
  title: string;
  hasBadge: boolean;
  country: string;
  revenues: string;
  pageLink: string;
  className: string;
  dataCy?: string;
}
const CompanyCard = React.forwardRef((props: CompanyCardProps, ref: ForwardedRef<HTMLDivElement> | null) => {
  const { title, hasBadge, country, revenues, pageLink, className = '', dataCy = '' } = props;
  const [showToolTip, setShowToolTip] = useState(false);
  const isDesktop = useBreakpoint('lgMin');
  return (
    <S.Wrapper
      ref={ref}
      className={className}
      data-cy={dataCy}
    >
      <S.TitleContainer>
        {hasBadge && (
          <button
            type='button'
            className='checkmark-badge'
            aria-label='Check company description'
            onClick={() => {
              if (!isDesktop) setShowToolTip(true);
            }}
            onMouseEnter={() => {
              if (isDesktop) setShowToolTip(true);
            }}
            onMouseLeave={() => {
              if (isDesktop) setShowToolTip(false);
            }}
            data-cy={`${dataCy}-badge`}
          >
            <SvgIcon
              name='Verified'
              className='checkmark-badge'
            />
          </button>
        )}
        <S.Title
          href={pageLink}
          data-cy={`${dataCy}-title`}
        >
          {title}
        </S.Title>
      </S.TitleContainer>
      {showToolTip && (
        <S.ToolTip data-cy={`${dataCy}-tooltip`}>
          <S.CloseToolTip
            onClick={() => {
              setShowToolTip(false);
            }}
          />
          <p>Fortune Premium Company Page</p>
        </S.ToolTip>
      )}
      <S.ListContainer data-cy={`${dataCy}-content`}>
        {country && (
          <S.ListRow>
            <S.ListCategory>Country:</S.ListCategory>
            <S.ListItem>{country}</S.ListItem>
          </S.ListRow>
        )}
        {revenues && (
          <S.ListRow>
            <S.ListCategory>Revenues ($M):</S.ListCategory>
            <S.ListItem>{revenues}</S.ListItem>
          </S.ListRow>
        )}
      </S.ListContainer>
      <Link
        href={pageLink}
        type='tertiaryButton'
        tabIndex={-1}
        dataCy={`${dataCy}-link`}
      >
        View Company Page
      </Link>
    </S.Wrapper>
  );
});

export default CompanyCard;
